var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprite.svg#icon-contact-bg-violet';
                    var viewUrl = 'sprite.svg#view-icon-contact-bg-violet';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 60 41',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };